import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { AiFillPieChart } from "react-icons/ai";
import { FaEnvelope } from "react-icons/fa";
import { IoPersonSharp } from "react-icons/io5";
import { PiDesktopTowerFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import PageHeader from "../../Components/PageHeader";

const Home = () => {
  const theme = useSelector((state) => state.theme);
  const applications = useSelector((state) => state.application);
  const messages = useSelector((state) => state.message);
  const users = useSelector((state) => state.user);
  const messagesNonLus = messages.filter((message) => message.readAt === null);
  const nbrDownload = [...applications].reduce(
    (acc, curr) => acc + curr.nbr_telechargement.length,
    0
  );
  const auth = useSelector((state) => state.auth);

  const downloadMois = (data) => {
    const allDownload = data.flatMap((app) =>
      Array.isArray(app.nbr_telechargement) ? app.nbr_telechargement : []
    );

    const comptMensuel = allDownload.reduce((acc, item) => {
      const dateDownload = new Date(item.createdAt);
      if (dateDownload.getUTCFullYear() !== new Date().getUTCFullYear()) {
        return acc;
      }
      const mois = dateDownload.getMonth() + 1;
      acc[mois] = (acc[mois] || 0) + 1;
      return acc;
    }, {});

    return Array.from(
      { length: new Date().getMonth() + 1 },
      (_, i) => comptMensuel[i + 1] || 0
    );
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
  );

  const chartColor = theme === "light" ? "#3d392f" : "#ebe7df";
  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        titleColor: "#ebe7df",
        bodyColor: "#ebe7df",
      },
      legend: {
        display: false,
        position: "bottom",
        labels: {
          color: chartColor,
        },
      },
      title: {
        display: true,
        text: `Nombre d'applications Téléchargées par mois ${new Date().getUTCFullYear()}`,
        color: chartColor,
      },
    },
    scales: {
      x: {
        ticks: {
          color: chartColor,
        },
      },
      y: {
        ticks: {
          color: chartColor,
        },
      },
    },
  };

  const labels = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Julliet",
    "Aout",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: "Nombre d'applications Téléchargées",
        data: downloadMois(applications),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.1)",
        tension: 0.4,
      },
    ],
  };

  document.title = "DashBoard | Accueil";

  return (
    <>
      <PageHeader page="Accueil" />
      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          {/* Small boxes (Stat box) */}
          <div className="row">
            <div className="col-lg-3 col-xs-6">
              {/* small box */}
              <NavLink to="applications">
                <div
                  className="small-box bg-blue"
                  style={{ backgroundColor: "red" }}
                >
                  <div className="inner">
                    <h3>
                      {applications && applications.length < 10
                        ? `0${applications.length}`
                        : applications.length}
                    </h3>
                    <p>Application{applications.length > 1 && "s"}</p>
                  </div>
                  <div className="icon">
                    <PiDesktopTowerFill />
                  </div>
                  <div className="small-box-footer">
                    Plus d'infos <i className="fa fa-arrow-circle-right" />
                  </div>
                </div>
              </NavLink>
            </div>
            {/* ./col */}
            <div className="col-lg-3 col-xs-6">
              {/* small box */}
              <NavLink to="messages">
                <div className="small-box bg-green">
                  <div className="inner">
                    <h3>
                      {messagesNonLus && messagesNonLus.length < 10
                        ? `0${messagesNonLus.length}`
                        : messagesNonLus.length}
                    </h3>
                    <p>
                      Message{messagesNonLus.length > 1 && "s"} non lu
                      {messagesNonLus.length > 1 && "s"}
                    </p>
                  </div>
                  <div className="icon">
                    <FaEnvelope />
                  </div>
                  <div className="small-box-footer">
                    Plus d'infos <i className="fa fa-arrow-circle-right" />
                  </div>
                </div>
              </NavLink>
            </div>
            {/* ./col */}
            {auth.roles && auth.roles?.includes("ROLE_ADMIN") && (
              <div className="col-lg-3 col-xs-6">
                {/* small box */}
                <NavLink to="utilisateurs">
                  <div className="small-box bg-yellow">
                    <div className="inner">
                      <h3>
                        {users && users.length < 10
                          ? `0${users.length}`
                          : users.length}
                      </h3>
                      <p>Utilisateur{users.length > 1 && "s"}</p>
                    </div>
                    <div className="icon">
                      <IoPersonSharp />
                    </div>
                    <div className="small-box-footer">
                      Plus d'infos <i className="fa fa-arrow-circle-right" />
                    </div>
                  </div>
                </NavLink>
              </div>
            )}
            {/* ./col */}
            <div className="col-lg-3 col-xs-6">
              {/* small box */}
              {/* <a href="#"> */}
              <div className="small-box bg-red">
                <div className="inner">
                  <h3>{nbrDownload}</h3>
                  <p>Nombre de téléchargements</p>
                </div>
                <div className="icon">
                  <AiFillPieChart />
                </div>
                <div className="small-box-footer">
                  Plus d'infos <i className="fa fa-arrow-circle-right" />
                </div>
              </div>
              {/* </a> */}
            </div>
            {/* ./col */}
          </div>
          {/* /.row */}
          <div className="row">
            {/* Left col */}
            <section className="col-lg-8">
              <Line options={options} data={data} />
            </section>
          </div>
        </div>
        {/*/. container-fluid */}
      </section>
      {/* /.content */}
    </>
  );
};

export default Home;
